module.exports = __webpack_public_path__ + "media/images/map_icons/Rugby-8f5b8aceb63e91f0e2bc1454527256d8.svg";